import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $RadioButtonWrapper = styled.div`
  [class*='RadioCardWithCheckboxColumnstyles__RadioCardContainer-'] {
    border-radius: ${({ theme }) => theme.tw.radius.lg};
  }
  [class*='RadioCardWithCheckboxColumnstyles__RadioCardTitle'] {
    padding-bottom: unset;
  }
  [class*='RadioCardWithCheckboxColumnstyles__ChooseProductCardCheckboxContainer-'] {
    display: none;
  }
`;

export const $Question = styled.div`
  ${fontStyle('lg')};
  color: ${({ theme }) => theme.colors.black};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing('xxl')};
`;
